var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"pa-0 ma-0"},[_c('v-overlay',{attrs:{"value":true,"opacity":"1","z-index":"200","color":"primary"}},[_c('CsPhoneVerification',{attrs:{"api-base-url":_vm.apiBaseUrl,"token":_vm.token,"language":_vm.currentLocale,"logo":_vm.logoComponent},on:{"set-company":_vm.handleSetCompany}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }